import { render } from "./smtp-import-logs.vue?vue&type=template&id=124498d2&ts=true"
import script from "./smtp-import-logs.vue?vue&type=script&lang=ts"
export * from "./smtp-import-logs.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__